import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {FrameDetailsView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/FrameDetailsView';
import {SpreadsheetHeader} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/SpreadsheetHeader';
import {MeshContextProvider} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/MeshContextProvider';
import {MeshView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/mesh/MeshView';
import {SpreadsheetTabsView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/tabsPanel/SpreadsheetTabsView';
import {WorkbookId} from '@mintdata/mint-kit/api/models/Identifiers';
import {IStyles, Styles} from '@mintdata/mint-kit/impl/util/Styles';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const themeStyles = require('./SpreadsheetView.less');
const cx = classnames.bind(themeStyles);

export interface ISpreadsheetViewProps
{
    workbookId:WorkbookId;
    theme?:IStyles;
}

@observer
export class SpreadsheetView extends React.Component<ISpreadsheetViewProps, any>
{
    public componentWillMount():void
    {
        const {theme} = this.props;
        this._initStyles(theme);
    }

    public componentDidMount():void
    {
        document.addEventListener('mousemove', this._mouseMoveDocumentHandler);
        document.addEventListener('mouseup', this._mouseUpDocumentHandler);
    }

    public componentWillReceiveProps(newProps:ISpreadsheetViewProps):void
    {
        const {theme} = this.props;

        if( theme !== newProps.theme )
            this._initStyles(newProps.theme);
    }

    public componentWillUnmount():void
    {
        const {mesh, meshMouse} = controllers.ui.spreadsheets;
        meshMouse.stopTrackingMouseOutsideMesh(mesh.getContextOfFocusedSheet());

        document.removeEventListener('mousemove', this._mouseMoveDocumentHandler);
        document.removeEventListener('mouseup', this._mouseUpDocumentHandler);
    }

    private _mouseMoveDocumentHandler(event:MouseEvent):void
    {
        const {meshMouse} = controllers.ui.spreadsheets;
        meshMouse.onDocumentMouseMove(event);
    }

    private _mouseUpDocumentHandler(event:MouseEvent):void
    {
        const {meshMouse} = controllers.ui.spreadsheets;
        meshMouse.onDocumentMouseUp(event);
    }

    private _initStyles(theme:IStyles):void
    {
        this.setState({
            styles: Styles.mergeStyles(themeStyles, theme || {})
        });
    }

    public render():JSX.Element
    {
        const {workbookId} = this.props;

        if( !workbookId )
            return null;

        const {surfaceArea, spreadsheets: {tabs, frameDetails}} = controllers.ui;
        const activeSheet = tabs.getActiveSheet(workbookId);

        const activePage:Page = surfaceArea.getActivePage();

        if( !activeSheet || !activePage )
            return null;

        const showFrameDetailsView:boolean = frameDetails.getStack(workbookId, activeSheet.id).length > 0;

        return (
            <div className={cx('spreadsheetView')}>
                <SpreadsheetHeader />

                <div className={cx('meshAndFrameSection')}>
                    <MeshContextProvider workbookId={workbookId} sheetId={activeSheet.id}>
                        <MeshView theme={themeStyles} />
                    </MeshContextProvider>
                    {
                        showFrameDetailsView &&
                        <FrameDetailsView workbookId={workbookId} sheetId={activeSheet.id} />
                    }
                </div>

                <div className={cx('spreadsheetViewTabsContainer')}>
                    <SpreadsheetTabsView
                        ref={(ref) => tabs.setTabsViewInstance(workbookId, ref)}
                        theme={themeStyles}
                        workbookId={workbookId}
                    />
                </div>
            </div>
        );
    }
}
